import { StyleSheet, Text, View } from 'react-native'
import * as AreaTypes from "./_areaType"
import React from 'react'

type Props = {
    areasList: any,
    areaId: Number,
    areaType: String,
}

const useAreaListByAreaType = (areasList: any, areaId: any, areaType: String = AreaTypes.BATHROOM) => {
    var _areas: any = []
    var _areasByAreaType = []
    // === find subAres ===
    for (var a in areasList) {
        var area = areasList[a];
        if (area && (area.areaId === areaId || area.areaUId === areaId)) {
            var _subAreas = area.subAreas
            for (var i in _subAreas) {
                const _subArea = _subAreas[i]
                const a = typeof _subArea == "object" ? _subArea.areaId || _subArea.areaUId : _subArea
                const findSubAreaList = areasList.find((areaItem: any) => { return areaItem.areaId == a || areaItem.areaUId == a })
                _areas.push(findSubAreaList)
            }
        }
    }
    // === find Area by areaType ===
    if (_areas && _areas !== 0) {
        const result = _areas.filter((_area: any) => _area?.areaType === areaType)
        _areasByAreaType.push(result)
    }
    return _areasByAreaType[0]
}

export default useAreaListByAreaType;